
import { TrainingSessionForm } from "@/components/training-sessions/TrainingSessionForm";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

const NewTrainingSession = () => {
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("training-sessions");
  
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950 dark:text-white">{t("newSession")}</h2>
        <p className="text-muted-foreground dark:text-gray-300">
          {t("subtitle")}
        </p>
        <Breadcrumb className="flex-wrap">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80">{t("breadcrumbs.dashboard")}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/dashboard/training-sessions")} className="text-flame hover:text-flame/80">{t("title")}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium dark:text-white">{t("newSession")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <TrainingSessionForm />
    </div>
  );
};

export default NewTrainingSession;
